import React from 'react';
import {
  SimpleModal,
  Alert,
  Box,
  Grid,
  Icon,
  Icons,
  useTheme,
} from '@nextiva/next-ui-components';
import {
  COMPANY_SCHEDULES_TEXT,
  LOCATION_SCHEDULES_TEXT,
  USER_SCHEDULES_TEXT,
} from 'containers/pages/Schedules/constants/ScheduleTypeDescription';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const theme = useTheme();

  return (
    <SimpleModal
      title="Type of schedules"
      confirmButtonProps={{
        onClick: onClose,
        'data-testid':
          'PlatformAdminUI-Schedules-TypeOfSchedules-SimpleModal-CloseButton',
      }}
      confirmText="Close"
      open={isOpen}
      onClose={onClose}
    >
      <Alert
        fullWidth
        severity="info"
        data-testid="PlatformAdminUI-Schedules-TypeOfSchedules-ModalAlert"
      >
        To activate schedules, they must be assigned to Users, Locations, Call
        flows, or Teams.
      </Alert>
      <Box sx={{ width: '100%', overflowY: 'auto', marginTop: '32px' }}>
        <Grid container flexDirection="column" spacing={1}>
          <Grid item>
            <Grid container alignItems="baseline" spacing={1}>
              <Grid item xs={1}>
                <Icon
                  icon={Icons.building}
                  sx={{
                    color: theme.palette.blueGrey.A400,
                    fontSize: '22px',
                  }}
                />
              </Grid>
              <Grid item xs={11}>
                {COMPANY_SCHEDULES_TEXT}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              container
              alignItems="baseline"
              spacing={1}
              style={{ marginTop: '32px', display: 'flex' }}
            >
              <Grid item xs={1}>
                <Icon
                  icon={Icons.location}
                  sx={{
                    color: theme.palette.blueGrey.A400,
                    fontSize: '22px',
                  }}
                />
              </Grid>
              <Grid item xs={11}>
                {LOCATION_SCHEDULES_TEXT}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              container
              alignItems="baseline"
              spacing={1}
              style={{ marginTop: '32px', display: 'flex' }}
            >
              <Grid item xs={1}>
                <Icon
                  icon={Icons.user}
                  sx={{
                    color: theme.palette.blueGrey.A400,
                    fontSize: '22px',
                  }}
                />
              </Grid>
              <Grid item xs={11}>
                {USER_SCHEDULES_TEXT}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </SimpleModal>
  );
};

export default Modal;
